/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { StoryElement } from "@quintype/components";
import PropTypes from "prop-types";
import { withElementWrapper } from "../withElementWrapper";
import { shapeStory, shapeConfig } from "../../../../utils/utils";
import "./video.m.css";

const Videobase = ({ element, story = {}, config = {}, ...restProps }) => {
  return (
    <div styleName="container" {...restProps}>
      <StoryElement element={element} />
    </div>
  );
};

export const Video = withElementWrapper(Videobase);

Videobase.propTypes = {
  element: PropTypes.object,
  story: shapeStory,
  config: shapeConfig
};
